'use client'

import _ from 'lodash'
import { memo, useMemo } from 'react'
import { Container } from '@/components'
import { useGlobalStore } from '@/store/provider'

const formatPath = (path: string): string => {
  if (path === '/') return 'Home'
  const x = _.chain(path)
    .split('/')
    .drop(1)
    .map((p) => _.startCase(p))
    .value()
  return x.join(' > ')
}

const OnlineCruzUsers = memo(() => {
  const { onlineCruzUsers } = useGlobalStore((state) => state)

  const { total, userEntries } = useMemo(() => {
    const totalCount = _.sum(_.values(onlineCruzUsers || {}))
    const entries = _.map(_.keys(onlineCruzUsers || {}), (key) => [key, _.get(onlineCruzUsers, key)])

    return {
      total: totalCount,
      userEntries: entries,
    }
  }, [onlineCruzUsers])

  const formattedTotal = useMemo(() => total?.toLocaleString() || '0', [total])

  return (
    <div>
      <h2 className='flex items-baseline justify-between font-semibold text-xl/8 leading-8 py-3'>
        <span>Online Cruz Users</span>
        <span className='font-serif'>{formattedTotal}</span>
      </h2>
      <div className='overflow-x-auto'>
        <table className='min-w-full divide-y border-t border-b'>
          <thead>
            <tr>
              <th scope='col' className='th text-left'>
                Page
              </th>
              <th scope='col' className='th text-right'>
                Count
              </th>
            </tr>
          </thead>
          <tbody className='divide-y'>
            {_.map(userEntries, ([key, count], idx) => (
              <tr key={key || idx} className='odd:bg-zinc-100 dark:odd:bg-zinc-800'>
                <td className='td truncate'>{formatPath(key)}</td>
                <td className='td text-right'>{count?.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
})

export const Home = memo(() => {
  return (
    <Container size='sm'>
      <OnlineCruzUsers />
    </Container>
  )
})
